import { render, staticRenderFns } from "./ScheduleController.vue?vue&type=template&id=38f5810b"
import script from "./ScheduleController.vue?vue&type=script&lang=js"
export * from "./ScheduleController.vue?vue&type=script&lang=js"
import style0 from "./ScheduleController.vue?vue&type=style&index=0&id=38f5810b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports